import { TransformedLayoverData } from '@/src/utils/itinerary/flightTransformers'
import { useTranslations } from 'next-intl'
import LayoverBlock from './layoverBlock'

interface LayoverBlockWrapperProps {
    layoverData: TransformedLayoverData
}

const LayoverBlockWrapper = ({ layoverData }: LayoverBlockWrapperProps) => {
    const t = useTranslations('common')
    const { layoverDuration, layoverAirport, airportCode, layoverType } = layoverData

    const formattedLayoverDuration = t('duration', {
        hours: layoverDuration.hours,
        minutes: layoverDuration.mins
    })
    const layoverText = t('layoverAirportName', {
        layoverAirport,
        airportCode
    })
    const prefix = {
        layover: t('layover'),
        in: t('in')
    }
    const formattedLayoverType = t(layoverType.toLowerCase())

    return (
        <LayoverBlock
            prefix={prefix}
            layoverDuration={formattedLayoverDuration}
            layoverText={layoverText}
            layoverType={formattedLayoverType}
        />
    )
}

export default LayoverBlockWrapper
